<p>{{ data.content }}</p>
<div *ngIf="data.links" class="mb-3">
  <ng-container *ngFor="let item of data.links">
    <p><a [href]="item.link" target="_blank">{{item.name}}</a></p>
  </ng-container>
</div>
<div class="d-flex align-items-center justify-content-center">
  <button mat-button
    mat-dialog-close>{{ 'OK' | translate }}</button>
</div>